export default __webpack_public_path__ + "static/media/weth-icon.4ea23027.png";